export default {
  fields: [{
      name: 'spare_part',
      label: "Pièce de rechange",
      type: 'select',
    formatter: (context, value) => value ? value.name : null,
    inPdfExport: true,
    },
    {
      name: 'line_title',
      label: "Titre",
      type: 'text',
      inPdfExport: true,
    },
    {
      name: 'line_comment',
      label: "Commentaire",
      type: 'text',
      inPdfExport: true,
    },
    {
      name: 'unit_price',
      label: "Prix unitaire",
      type: 'number',
      step: 0.01,
      formatter: (context, value) => value ? parseFloat(value).toFixed(2) + '€' : null,
      inPdfExport: true,
    },
    {
      name: 'quantity',
      label: "Quantité",
      type: 'number',
      inPdfExport: true,
    },
    {
      name: 'total',
      label: "Total",
      type: 'number',
      step: 0.01,
      formatter: (context, value) => value ? parseFloat(value).toFixed(2) + '€' : null,
      inPdfExport: true,
    }
  ]
}



// WEBPACK FOOTER //
// ./src/components/ManualBillingLine/config.js